import { LitElement, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-provider-page.global.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

/**
 * The OutlineProviderPage component
 * @element outline-provider-page
 */
@customElement('outline-provider-page')
export class OutlineProviderPage extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-provider-page': OutlineProviderPage;
  }
}
